class ajaxCart {
   init(){
     var self = this;
 
     $('#AddToCart').off('click').on('click', function(e){
      e.preventDefault();
       var sel = $(this).siblings('#variant');
       if(sel){
         var val = $(sel).val();
         if(val=='') {
           e.preventDefault();
           $(sel).addClass('shake');
           var notis = $('<span class="size-notice">Please select a size first</span>');
           $(notis).insertAfter('#variant');
           $('.size-notice').hide().fadeIn(200);
 
           if(window.innerWidth <= 787) {
             $('#variant option').first().text('Please select a size first');
           }
 
           setTimeout(function(){
             $(sel).removeClass('shake');
             $('.size-notice').fadeOut(200, function(){
               $('#variant option').first().text('Size');
               $(this).remove();
             });
           }, 3500);
         } else {
           console.log(val);
           $.ajax({
             type: 'POST',
             url: '/cart/add.js',
             data: {
               quantity: 1,
               id: val
             },
             dataType: 'json',
             success: function (data) {
               $('.hc-items-count').text(data.quantity);
               console.log(data);
               $('body').addClass('active_slide_cart');
               self.update();
             },
              error: function (data) {
                console.log(data);
                if(data.responseJSON.description) {
                  let newItem = $('<span id="err">'+data.responseJSON.description+'</span>');
                  newItem.insertAfter('#AddToCart');
                  $('#AddToCart').addClass('shake');
                  $('body').addClass('active_slide_cart');
                  setTimeout(function(){
                    $('#AddToCart').removeClass('shake');
                    $('#err').slideUp(300, 'linear', function(){
                      $(this).remove();
                    });
                  }, 3500);
                }
              }
           });
         }
       }
     });
 
     $("#mini-cart").on('mousedown touchstart', function(){
       clearTimeout(window.autoCloseCart);
     });
 
     $('.cart-tog, .custom-overlay').click(function(event) {
       event.preventDefault();
       $(".custom-overlay").toggle();
       jQuery('body').toggleClass('active_slide_cart');
     });
 
     $('.cart-title, .hc-close').click(function() {
       $(".custom-overlay").hide();
       jQuery('body').removeClass('active_slide_cart');
     });
 
     $(document).on('click', '.plus-quantity',function(e){
       e.preventDefault();
       var $input = $(this).siblings('.quantity-input');
       var newValue = parseInt($input.val()) + 1;
       $input.val(newValue).trigger('change');
       return false;
     });
 
     $(document).on('click', '.minus-quantity',function(e){
       e.preventDefault();
       var $input = $(this).siblings('.quantity-input');
       var newValue = parseInt($input.val()) - 1;
       $input.val(newValue).trigger('change');
       return false;
     });
 
     $(document).on('click', '.hc-remove',function(e){
       e.preventDefault();
       var $input = $(this).siblings('.item-details--quantity--buts').find('.quantity-input');
       $input.val('0').trigger('change');
       $(this).parents('.item-details').slideToggle(400);
       return false;
     });
 
     $(document).on('change', '.quantity-input', function() {
       var id = $(this).closest('.item-details').data('id');
       var val = parseInt($(this).val());
       self.update(id, val);
       return false;
     });
 
     $('.ordernote--toggle').click(function(e){
       e.preventDefault();
       if(!$('.ordernote--message').is(':visible')){
         setTimeout(function(){
           var val = $('.ordernote--message--area').val();
           $('.ordernote--message--area').focus();
           $('.ordernote--message--area').get(0).setSelectionRange(val.length, val.length);
         }, 320);
       }
       $('.ordernote--message').toggle(300);
     });
 
      if($('.ordernote--message--area').length>0){
         if($('.ordernote--message--area').val().length>0) {
            $('.ordernote--message').show();
         }
      }
 
     $('.ordernote--message--area').unbind('keyup').on('keyup', function(){
       var val = $(this).val();
       clearTimeout(window.cartNoteTimeout);
       $('a.checkout').addClass('disabled');
       window.cartNoteTimeout = setTimeout(function(){
         fetch(window.routes.cartUrl + '/update.js', {
           body: JSON.stringify({ note: val }),
           credentials: 'same-origin',
           method: 'POST',
           headers: {
             'Content-Type': 'application/json',
             'X-Requested-With': 'XMLHttpRequest'
           }
         }).then(function(response){
           $('a.checkout').removeClass('disabled');
           console.log(response);
         });
       }, 1000);
     });
 
     if(window.innerWidth < 768) {
       if($('.hc-items-count').first().text()!==''){
         $('.mobile-menu--right .cart-tog').show();
       }
     }
 
    //  self.update();
   }
 
   update(id = null, val = null) {
     // console.log('updating cart');
 
     var $update = {};
     if(id!==null && val!==null) {
       $update[id] = val;
     }
 
     $.ajax({
       method: 'POST',
       dataType: 'json',
       data: { updates: $update },
       url: window.routes.cartUrl+'/update.js',
       success: function(){
         // console.log('success');
         $.getJSON('/cart.js', function(cart) {
           // console.log(cart);
           var size = cart.item_count;
           $('.hc-items-count').text('('+size+')');
           $('.hc-mini-table').remove();
 
           if(window.innerWidth < 768) {
             if(size < 1) {
               $('.mobile-menu--right .cart-tog').hide();
             } else {
               $('.mobile-menu--right .cart-tog').show();
             }
           }
 
           $('.amount').text(Shopify.formatMoney(cart.total_price, Shopify.money_format));
           $('.hc-append').append('<table class="hc-mini-table">');
 
           $(cart.items).each(function(index, item) {
             $('.hc-mini-table').append(`
               <tr class="item-details" data-id="${item.id}">
               <td class="item-details--image">
               <a href="${item.url}"><img src="${item.image}" /></a></td>
               <td class="item-details--text">
               <div class="item-details--text--string first">
                 <a href="${item.url}">
                 ${item.product_title}
                 </a>
               </div>
               <div class="item-details--text--string split vendor">${item.vendor}</div>
               <!--div class="item-details--text--string split">${item.variant_title}</div-->
               <span class="item-details-price item-price">${Shopify.formatMoney(item.final_price,  Shopify.money_format, window.Shopify.getSymbol())}</span>
               </td>
               <td class="item-details--quantity">
               <div class="item-details--quantity--buts">
               <a href class="minus-quantity">&minus;</a>
               <input type="text" class="quantity-input" value="${item.quantity}">
               <a href class="plus-quantity">&plus;</a>
               </div>
               <a class="hc-remove" href="">Remove</a>
               </td>
               </tr>
               `);
             });
 
 
             $('.hc-append').append('</table>');
             // $('#CartCount > span').text(size);
           });
         },
         error: function(message){
           console.log(message);
         }
       });
   }
 }
 export default ajaxCart;
 